import { CloudActions, CloudUtils } from '@portal/portal-core';

interface DeepLinkConfig {
  shouldUpdateQueryParams: () => boolean;
}

interface DeepLinkAction {
  type: string;
  costCenterId?: string;
}

type NextDispatch = (action: DeepLinkAction) => unknown;

// Exports a function that takes consumer-provided config and returns the middleware. Consumer must
// provide `shouldUpdateQueryParams`, even if it's a no-op.
export const DeepLinkMiddleware =
  (config: DeepLinkConfig) =>
    () =>
      (next: NextDispatch) =>
        (action: DeepLinkAction): unknown => {
          if (!config.shouldUpdateQueryParams()) {
            return next(action);
          }

          switch (action.type) {
            case CloudActions.USER_ADMIN_FORCE_UPDATE:
              CloudUtils.updateQueryParams({
                costCenter: action.costCenterId,
              });
              break;
            default:
              return next(action);
          }

          return next(action);
        };
